<script setup lang="ts">

import { useSamplePresentation } from './SamplePresentation';
import Presentation from '@presentation/Templates/Presentation.vue';

useSamplePresentation(); 

</script>

<template>
    <Presentation />
</template>